import { cn } from '@savgroup-front-common/primitive/lib/utils';

export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'revers-skeleton',
        'animate-pulse rounded-md bg-surface-disabled-default',
        className,
      )}
      {...props}
    />
  );
}
